import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ModalContentContainer = styled.div`
  width: 80%;
  height: fit-content;
  max-width: 618px;
  max-height: 340px;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  position: relative;
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
`;
export const ContentModal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalHeader = styled.div`
  height: 50px;
  width: 96%;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  margin: 0 2%;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
  .close-button {
    position: absolute;
    right: 0;
    top: 0.6em;
    padding: 0 !important;
  }
`;

export const ModalTitle = styled.label`
  font-size: 18px;
  color: ${({ theme }) => theme.primary.purple};
  font-weight: 700;
`;
export const ModalContent = styled.div`
  margin-top: 5px;
  width: 100%;
  height: fit-content;
  padding: 0 5%;
  overflow-y: auto;
  max-height: 228px;
  display: flex;
  flex-direction: column-reverse;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #b1b1b1;
  }
`;
export const MessageContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 2fr;
  grid-column-gap: 20px;
  margin: 10px 0;
  svg {
    align-self: end;
    visibility: ${({ showIcon }) => (showIcon ? "visible" : "hidden")};
    color: ${({ theme }) => theme.primary.purple};
    width: 28px;
    height: 28px;
  }
`;
export const Message = styled.div`
  width: 100%;
  background: #eeeeee;
  border-radius: 10px;
  font-weight: 400;
  font-size: 28px;
  line-height: 38px;
  padding-left: 10px;
`;
export const ActionButton = styled.div`
  width: 89%;
  margin: 2% 5%;
  display: flex;
  justify-content: flex-end;
`;
export const ButtonOk = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 67px;
  height: 34px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  color: white;
  cursor: pointer;
  right: 0;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: rgba(46, 46, 46, 1);
  }
`;
